module.exports = __webpack_public_path__ + "img/logo-cabecera-dinapsis.ab1b5bfb.svg";